import React, { Component } from "react";
import { connect } from "react-redux";
import { constants } from "../../../firebase/firestoreNameSpaces";
import * as actions from "../../../store/actions/index"

class PaymentType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
    };
    this.togglePaymentType = this.togglePaymentType.bind(this);
  }

  togglePaymentType(e,id) {
    e.preventDefault(); 
    // let id = e.target.id;
    this.setState({ id: id });
    this.props.onSelectPaymentType(id);
  }
 
  render() {
     
    return (
      <div className="text-center" style={{ marginTop: "10vh" }}>
        
       {this.props.COD&&( <button
          id={constants.PAYMENT_CASH}
          className={`btn col-md-4 mb-4 m-auto py-4 ${
            `${constants.PAYMENT_CASH}` === this.state.id || this.props.paymentType === constants.PAYMENT_CASH
              ? "btn-primary bg-primary"
              : "btn-outline-primary"
          }`}
          // style={{backgroundColor:"transparent",color:"#007bff"}}
          onClick={(e) => this.togglePaymentType(e,constants.PAYMENT_CASH)}
        >
          Pay on Delivery
        </button>)}
        <br />
        {this.props.Prepaid&&(<button
          id={constants.PAYMENT_ONLINE_ORDER}
          // style={{backgroundColor:"transparent",color:"#28a745"}}
          className={`btn col-md-4 mb-4 mt-4  py-4 ${
           constants.PAYMENT_ONLINE_ORDER === this.state.id || this.props.paymentType === constants.PAYMENT_ONLINE_ORDER
              ? "btn-success"
              : "btn-outline-success"
          }`}
          onClick={(e) => this.togglePaymentType(e,constants.PAYMENT_ONLINE_ORDER)}
        >
          Online Payment
        </button>)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    paymentType: state.cart.order.payment_mode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSelectPaymentType: (paymentType) =>
      dispatch(actions.onSelectPaymentType(paymentType)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentType);